import isDeepEqual from 'fast-deep-equal'
import { z } from 'zod'

import type { ContextualValuesChangedAction } from '../types/actions'

import { actionFactory } from './factory'

export const ContextualDataSchema = z.record(z.string(), z.string()).optional()

export const contextualValuesChanged =
  actionFactory<ContextualValuesChangedAction>(
    (state, { contextualValues }) => {
      if (!state.appParams) {
        throw new Error('Expected appParams to to be set')
      }

      // TODO: remove temporary measure to prevent an infinite loop
      if (isDeepEqual(contextualValues, state.appParams.contextualValues))
        return

      state.appParams.contextualValues =
        ContextualDataSchema.parse(contextualValues)
    },
    'contextualValuesChanged'
  )
